const translations: Record<string, string> = {
  "ak_scada_normal": "Normal",
  "ak_scada_warning": "Warning",
  "ak_scada_alarm": "Alarm",
  "ak_scada_no_link": "No link",
  "ak_scada_curtailed": "Curtailed",
  "ak_scada_planned_maintenance": "Planned maintenance",
  "ak_scada_commissioning": "Commissioning",
  "ak_scada_collector_cycle_1_min": "collector cycle ~1 min",
  "ak_scada_collector_cycle_5_min": "collector cycle ~5 min",
  "ak_scada_no_data": "no data",
  "ak_scada_s_ago": "{{n}} s ago",
  "ak_scada_min_ago": "{{n}} min ago",
  "ak_scada_h_min_ago": "{{h}} h {{m}} min ago",
  "ak_scada_d_ago": "{{n}} d ago",
  "ak_scada_online": "online",
  "ak_scada_data_is_getting_stale": "data is getting stale",
  "ak_scada_no_link_2": "no link",
  "ak_scada_data_quality": "Data quality: {{q}}",
  "ak_scada_active_power": "Active power",
  "ak_scada_mw": "MW",
  "ak_scada_kw": "kW",
  "ak_scada_current": "Current",
  "ak_scada_new": "New",
  "ak_scada_cancel": "Cancel",
  "ak_scada_confirm_and_execute": "Confirm and execute",
  "ak_scada_soon": "Soon",
  "ak_scada_section_under_preparation": "Section under preparation",
  "ak_scada_dc_ac_mw": "DC {{dc}} / AC {{ac}} MW",
  "ak_scada_of_capacity": "{{p}}% of capacity",
  "ak_scada_inverters_running": "Inverters ({{w}}/{{n}} running)",
  "ak_scada_charge_for_the_hour_from": "Charge for the hour · from {{h}}",
  "ak_scada_charge_for_the_hour": "Charge for the hour",
  "ak_scada_discharge_for_the_hour_from": "Discharge for the hour · from {{h}}",
  "ak_scada_discharge_for_the_hour": "Discharge for the hour",
  "ak_scada_station_not_found": "Station not found",
  "ak_scada_unknown_station_identifier": "Unknown station identifier.",
  "ak_scada_station_power": "Station power",
  "ak_scada_inverters_online": "Inverters online",
  "ak_scada_generated_today": "Generated today",
  "ak_scada_mwh": "MWh",
  "ak_scada_dc_input": "DC input",
  "ak_scada_commercial_metering_dlms": "Commercial metering (DLMS)",
  "ak_scada_direct_dlms_reading_ozd": "direct DLMS reading (OZD)",
  "ak_scada_commercial_metering_data_is_not_availa": "Commercial metering data is not available for this station",
  "ak_scada_station_single_line_diagram": "Station single-line diagram",
  "ak_scada_point_of_connection_ktp_inverter_group": "Point of connection → KTP → inverter groups",
  "ak_scada_click_an_inverter_to_view_its_strings": "Click an inverter to view its strings",
  "ak_scada_bess": "BESS",
  "ak_scada_storage_is_listed_in_the_asset_registr": "storage is listed in the asset registry",
  "ak_scada_storage_data_is_currently_not_coming_f": "Storage data is currently not coming from SCADA. Check the connection to the station EMS BOX.",
  "ak_scada_this_solar_plant_has_no_energy_storage": "This solar plant has no energy storage.",
  "ak_scada_standby": "Standby",
  "ak_scada_charge": "Charge",
  "ak_scada_discharge": "Discharge",
  "ak_scada_idle": "Idle",
  "ak_scada_running": "Running",
  "ak_scada_offline": "Offline",
  "ak_scada_not_charging": "Not charging",
  "ak_scada_state_of_charge_soc": "State of charge (SOC)",
  "ak_scada_storage_kehua_pcs_jinko_battery": "storage · Kehua PCS + Jinko battery",
  "ak_scada_soc_level": "SoC level",
  "ak_scada_power_now": "power now",
  "ak_scada_ac_power": "AC power",
  "ak_scada_available_power": "Available power",
  "ak_scada_kwh": "kWh",
  "ak_scada_kva": "kVA",
  "ak_scada_dc_power": "DC power",
  "ak_scada_battery_voltage": "Battery voltage",
  "ak_scada_v": "V",
  "ak_scada_battery_current": "Battery current",
  "ak_scada_a": "A",
  "ak_scada_frequency": "Frequency",
  "ak_scada_hz": "Hz",
  "ak_scada_dc_voltage": "DC voltage",
  "ak_scada_dc_current": "DC current",
  "ak_scada_temperature": "Temperature",
  "ak_scada_pcs_heatsink": "PCS heatsink",
  "ak_scada_charge_for_the_day": "Charge for the day",
  "ak_scada_discharge_for_the_day": "Discharge for the day",
  "ak_scada_total_charged": "Total charged",
  "ak_scada_total_discharged": "Total discharged",
  "ak_scada_available_to_charge": "Available to charge",
  "ak_scada_available_to_discharge": "Available to discharge",
  "ak_scada_pcs_status": "PCS status",
  "ak_scada_bms_status": "BMS status",
  "ak_scada_charging": "charging",
  "ak_scada_discharging": "discharging",
  "ak_scada_standby_2": "standby",
  "ak_scada_fault": "fault",
  "ak_scada_no_fresh_data": "no fresh data",
  "ak_scada_estimate": "{{dir}} · estimate",
  "ak_scada_limit_kw": "limit {{kw}} kW",
  "ak_scada_active_alarms": "active alarms: {{n}}",
  "ak_scada_mode": "mode: {{m}}",
  "ak_scada_updated": "updated {{a}}",
  "ak_scada_point_of_connection": "Point of connection",
  "ak_scada_export_to_grid": "export to grid",
  "ak_scada_import_from_grid": "import from grid",
  "ak_scada_pv_plant": "PV plant",
  "ak_scada_inverters_online_2": "inverters online",
  "ak_scada_discharge_charge": "+ discharge · − charge",
  "ak_scada_batteries_online": "batteries online",
  "ak_scada_link": "Link",
  "ak_scada_station_status": "Station status",
  "ak_scada_mwh_2": "{{v}} MWh",
  "ak_scada_standby_3": "Standby",
  "ak_scada_bess_storage": "BESS / Storage",
  "ak_scada_consolidated_bess_status": "Consolidated BESS status",
  "ak_scada_to_charge": "To charge",
  "ak_scada_to_discharge": "To discharge",
  "ak_scada_charge_discharge_per_day": "Charge / discharge per day",
  "ak_scada_voltage": "Voltage",
  "ak_scada_charge_discharge_mwh": "{{d}} · charge {{c}} / discharge {{r}} MWh",
  "ak_scada_no_data_for": "No data for {{d}}.",
  "ak_scada_today": "Today",
  "ak_scada_for_the_current_day": "For the current day",
  "ak_scada_today_2": "today",
  "ak_scada_history_soc_and_power": "History: SoC and power",
  "ak_scada_history_is_not_available_for_this_stat": "History is not available for this station.",
  "ak_scada_loading": "Loading…",
  "ak_scada_power_kw": "Power, kW",
  "ak_scada_time": "Time",
  "ak_scada_mode_2": "Mode",
  "ak_scada_temp_c": "Temp., °C",
  "ak_scada_off": "Off",
  "ak_scada_derated": "Derated",
  "ak_scada_load": "% load",
  "ak_scada_battery": "Battery #{{id}}",
  "ak_scada_voltage_2": "Voltage:",
  "ak_scada_temp": "Temp:",
  "ak_scada_cells": "Cells:",
  "ak_scada_mv": "mV",
  "ak_scada_spread": "Spread:",
  "ak_scada_bess_converters_kehua_pcs": "BESS converters · {{n}}× Kehua PCS",
  "ak_scada_online_2": "online",
  "ak_scada_bess_batteries_jinko": "BESS batteries · {{n}}× Jinko",
  "ak_scada_available": "available",
  "ak_scada_power_dc_voltage_frequency_temperature": "Power · DC voltage · frequency · temperature · load per PCS",
  "ak_scada_soc_soh_pack_voltage_cell_balance_temp": "SOC · SOH · pack voltage · cell balance · temperature per battery",
  "ak_scada_s": "{{n}}s",
  "ak_scada_min": "{{n}}min",
  "ak_scada_h": "{{n}}h",
  "ak_scada_online_direct_dlms_reading_ozd": "{{o}}/{{c}} online · direct DLMS reading (OZD)",
  "ak_scada_error": "Error: {{e}}",
  "ak_scada_updated_ago": "updated {{a}} ago",
  "ak_scada_offline_2": "offline · {{s}}",
  "ak_scada_total": "total",
  "ak_scada_p_kw_today": "P {{p}} kW · +{{g}} today · {{a}}",
  "ak_scada_import": "Import",
  "ak_scada_export": "Export",
  "ak_scada_active_energy_export_generation": "Active energy, export (generation)",
  "ak_scada_active_energy_import_consumption": "Active energy, import (consumption)",
  "ak_scada_offline_3": "offline",
  "ak_scada_critical": "Critical",
  "ak_scada_warning_2": "Warning",
  "ak_scada_informational": "Informational",
  "ak_scada_replied": " · replied: {{n}}",
  "ak_scada_critical_2": "Critical ({{n}})",
  "ak_scada_warnings": "Warnings ({{n}})",
  "ak_scada_informational_2": "Informational ({{n}})",
  "ak_scada_active": "Active ({{n}})",
  "ak_scada_sequence_of_events": "Sequence of events ({{n}})",
  "ak_scada_archive": "Archive ({{n}})",
  "ak_scada_open_alarms_source_generation_monitori": "{{n}} open alarms · source: generation monitoring",
  "ak_scada_awaiting_response": " · awaiting response",
  "ak_scada_cleared": "cleared",
  "ak_scada_in_progress": "in progress",
  "ak_scada_active_2": "active",
  "ak_scada_all_categories": "All categories",
  "ak_scada_station": "Station",
  "ak_scada_device": "Device",
  "ak_scada_category": "Category",
  "ak_scada_event": "Event",
  "ak_scada_status": "Status",
  "ak_scada_response": "Response",
  "ak_scada_export_csv": "Export CSV",
  "ak_scada_active_events_and_alarms": "Active events and alarms",
  "ak_scada_no_active_events": "No active events.",
  "ak_scada_sequence_of_events_chronology": "Sequence of events (chronology)",
  "ak_scada_all_events_for_14_days_in_chronologica": "All events for 14 days in chronological order",
  "ak_scada_no_events": "No events.",
  "ak_scada_event_archive": "Event archive",
  "ak_scada_cleared_and_historical_records": "Cleared and historical records",
  "ak_scada_the_archive_is_empty": "The archive is empty.",
  "ak_scada_sko": "SKO",
  "ak_scada_operational_safety": "operational safety",
  "ak_scada_dso_technical_limit": "DSO / technical limit",
  "ak_scada_manual": "manual",
  "ak_scada_writing_setpoints_from_the_cabinet_is": "Writing setpoints from the cabinet is not enabled yet: the channel to the EMS box of the stations has not been introduced. The table shows actual values from telemetry; limits are currently set at the station. No action on this page changes equipment operation.",
  "ak_scada_stations_power_limits_and_link_status": "{{n}} stations · power, limits and link status of each station in one view",
  "ak_scada_mw_of": "MW of",
  "ak_scada_no_data_2": " · no data: {{n}}",
  "ak_scada_x": " · {{p}} % · {{r}}",
  "ak_scada_link_online_means_data_no_older_than_t": "Link: “online” means data no older than three collector cycles (Luchky ~1 min, others ~5 min); beyond that it is getting stale; over 40 min (Luchky - 15 min) means no link, and the power of such a station is excluded from the total. BESS: + discharge, − charge.",
  "ak_scada_view_only_mode": "View-only mode.",
  "ak_scada_fleet_control": "Fleet control",
  "ak_scada_status_2": "Status",
  "ak_scada_p_actual_mw": "P actual, MW",
  "ak_scada_installed_mw": "Installed, MW",
  "ak_scada_load_2": "Load",
  "ak_scada_limit": "Limit",
  "ak_scada_inverters": "Inverters",
  "ak_scada_control_channel": "Control channel",
  "ak_scada_source_unknown": "source unknown",
  "ak_scada_none": "none",
  "ak_scada_view_only": "view only",
  "ak_scada_total_2": "Total",
};

export default translations;
